'use strict';

var TDChartTimeOfDayFilterFactory = function TDChartTimeOfDayFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandClassFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartTimeOfDayFilter() {
    DemandFilter.call(this, 'service', 'thematic-demand-chart-service-time-of-day');
    this.registerFilters(injectedFilters);
  }
  TDChartTimeOfDayFilter.constructor = TDChartTimeOfDayFilter;
  TDChartTimeOfDayFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartTimeOfDayFilter;
};
TDChartTimeOfDayFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = TDChartTimeOfDayFilterFactory;